import { FC, useRef } from 'react';

import { Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { GridColDef } from '@material-ui/data-grid';
import FilterDrawer from 'src/components/FilterDrawer';
import { FilterDrawerRef } from 'src/components/FilterDrawer/interfaces';
import Table from 'src/components/Table';
import TableActions from 'src/components/Table/Actions';
import { columnDateTime } from 'src/components/Table/types';
import usePagination from 'src/hooks/usePagination';
import IOffer from 'src/interfaces/models/IOffer';
import OfferFilterSchema from 'src/validators/Offer/filter.schema';

import Filters from './Filters';
import { Container } from './styles';

const List: FC = () => {
  const filterRef = useRef<FilterDrawerRef>(null);
  const {
    handlePageChange,
    handlePageSizeChange,
    data,
    loading,
    info,
    loadData,
  } = usePagination<IOffer>('admin/campaigns');

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    {
      field: 'partner.display_name',
      headerName: 'Parceira',
      flex: 1,
      valueGetter({ row }) {
        return row.partner?.display_name;
      },
    },
    {
      field: 'service.name',
      headerName: 'Nome',
      flex: 1,
      valueGetter({ row }) {
        return row.service?.name;
      },
    },
    {
      field: 'campaign_start_at',
      headerName: 'Início',
      ...columnDateTime,
    },
    {
      field: 'campaign_end_at',
      headerName: 'Fim',
      ...columnDateTime,
    },
    {
      field: '',
      disableColumnMenu: true,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell({ row }) {
        return (
          <TableActions
            resource="Campanha"
            editLink={`/parceiras/${row.partner_id}/servicos/${row.id}`}
            descriptionPrefix={`A campanha ${row.id}`}
            onFinish={loadData}
          />
        );
      },
    },
  ];

  return (
    <Container>
      <FilterDrawer
        ref={filterRef}
        columns={columns.filter((column) => !column.hide && column.field)}
        yupSchema={OfferFilterSchema}
      >
        <Filters formRef={filterRef.current?.getFormRef()} />
      </FilterDrawer>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h5">Campanhas Especiais</Typography>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Table
                autoHeight
                rows={data}
                page={info.current_page - 1}
                pageSize={info.per_page}
                rowCount={info.total}
                columns={columns}
                loading={loading}
                pagination
                paginationMode="server"
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                onFilterClick={filterRef.current?.open}
                canSearch
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default List;
